export const MAX_SELECTED_ANTIBIOTICS = 10;
export const MAX_SELECTED_ANIMALS = 10;
export const MAX_SELECTED_SUBGROUPS = 5;
export const MAX_SELECTED_FORMS = 10;
export const MAX_SELECTED_ORDINATION_GROUPS = 10;

export const ANTIBIOTIC_GROUP_PREFIX = "__group__::";
export const DEFAULT_ANTIBIOTIC_GROUP_LABEL = "Other/unknown";
export const ANIMAL_SUPERGROUP_SENTINEL = "__all_animal_subgroups__";
export const ANIMAL_SUPERGROUP_LABEL = "Alle undergrupper";
export const SUBGROUP_MODE_FILTER_ONLY = "filter_only";
